// kpi-context.util.ts
export type KpiContext = 'Economics' | 'Energy';

/**
 * Deriva il bucket KPI per i detail drawer.
 * Priorità: drawerConfig.kpiContext > path-sniffing (fallback admin).
 */
export function resolveKpiContext(
  drawerConfig: { kpiContext?: string } | null | undefined,
  pathSegment: string | undefined
): KpiContext {
  const raw = drawerConfig?.kpiContext;
  if (raw) {
    return (raw.charAt(0).toUpperCase() + raw.slice(1)) as KpiContext;
  }
  return pathSegment?.includes('economics') ? 'Economics' : 'Energy';
}
